export const SET_VIDEOS = 'VIDEOS/SET_VIDEOS';
export const REMOVE_VIDEO = 'VIDEOS/REMOVE_VIDEO';
export const LOADIND_VIDEOS = 'VIDEOS/LOADIND_VIDEOS';
export const SET_ERROR = 'VIDEOS/SET_ERROR';

export const REMOVE_VIDEO_REQUEST = 'VIDEOS/REMOVE_VIDEO_REQUEST';
export const LOAD_VIDEOS_REQUEST = 'VIDEOS/LOAD_VIDEOS_REQUEST';
export const UPLOAD_VIDEO_REQUEST = 'VIDEOS/UPLOAD_VIDEO_REQUEST';
